'use es6';

import { createSelector } from 'reselect';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
const selectRoot = get('aiSettings');
export const selectGenerativeAIEnabled = createSelector(selectRoot, root => {
  return getIn(['settings', 'isGenerativeAiEnabled'], root);
});